import { useState } from 'react';
import questionIcon from '../../assets/icons/question.svg';
import Button from './Button';

const styles = {
	section: 'fixed inset-0 z-[9999] flex items-center justify-center p-4',
	backDrop: 'absolute inset-0 bg-black/70',
	modal: 'relative z-10 w-full max-w-[500px] rounded-[18px] bg-white shadow-2xl p-[30px]',
	heading: 'text-25 font-bold text-dark-blue mb-3 leading-100',
	subHeading: 'text-gray text-sm mb-8',
	label: 'text-base leading-100 font-medium text-dark-blue',
};

export default function SubAdminModal({
	isOpen,
	onClose,
	isEdit = false,
	initialFirstName = '',
	initialLastName = '',
	initialEmail = ''
}) {
	const [firstName, setFirstName] = useState(initialFirstName);
	const [lastName, setLastName] = useState(initialLastName);
	const [email, setEmail] = useState(initialEmail);

	if (!isOpen) return null;

	// const handleBackdropClick = (e) => {
	// 	if (e.target === e.currentTarget) onClose();
	// };

	const modalTitle = isEdit ? 'Edit sub-admin' : 'Add sub-admin';
	const modalSubHeading = isEdit
		? 'Update sub-admin infromation'
		: 'Assign limited admin access to a team member.';
	const primaryButtonText = isEdit ? 'Update information' : 'Add sub-admin';
	const firstNamePlaceholder = isEdit ? 'Zunair' : 'John';
	const lastNamePlaceholder = isEdit ? 'Khan' : 'Doe';
	const emailPlaceholder = isEdit ? 'zunairkhan@nesl-it.com' : 'john.doe@example.com';

	return (
		<div className={styles.section}
			// onClick={handleBackdropClick}
		>
			{/* Backdrop */}
			<div className={styles.backDrop} />

			{/* Modal */}
			<div className={styles.modal}>
				<svg
					onClick={onClose}
					className="absolute top-8 right-2 md:right-6 text-gray-400 hover:text-gray-600 transition cursor-pointer"
					width="25"
					height="26"
					viewBox="0 0 25 26"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g opacity="0.4">
						<path
							d="M8.75065 18.2085L12.5007 14.4585L16.2507 18.2085L17.709 16.7502L13.959 13.0002L17.709 9.25016L16.2507 7.79183L12.5007 11.5418L8.75065 7.79183L7.29232 9.25016L11.0423 13.0002L7.29232 16.7502L8.75065 18.2085ZM12.5007 23.4168C11.0597 23.4168 9.70551 23.1432 8.43815 22.596C7.17079 22.0488 6.06836 21.3068 5.13086 20.37C4.19336 19.4331 3.45135 18.3307 2.90482 17.0627C2.35829 15.7946 2.08468 14.4404 2.08399 13.0002C2.08329 11.5599 2.3569 10.2057 2.90482 8.93766C3.45274 7.66961 4.19475 6.56718 5.13086 5.63037C6.06697 4.69357 7.1694 3.95155 8.43815 3.40433C9.7069 2.85711 11.0611 2.5835 12.5007 2.5835C13.9402 2.5835 15.2944 2.85711 16.5632 3.40433C17.8319 3.95155 18.9343 4.69357 19.8704 5.63037C20.8066 6.56718 21.5489 7.66961 22.0975 8.93766C22.6461 10.2057 22.9194 11.5599 22.9173 13.0002C22.9152 14.4404 22.6416 15.7946 22.0965 17.0627C21.5513 18.3307 20.8093 19.4331 19.8704 20.37C18.9316 21.3068 17.8291 22.0491 16.5632 22.597C15.2972 23.145 13.943 23.4182 12.5007 23.4168Z"
							fill="#180A63"
						/>
					</g>
				</svg>

				{/* Heading */}
				<h2 className={styles.heading}>{modalTitle}</h2>
				<p className={styles.subHeading}>{modalSubHeading}</p>

				<div className="h-[1px] bg-[#F0F0F0] mb-[30px] mx-[-30px]" />

				{/* Input fields */}
				<div className="grid grid-cols-1 gap-6 mb-5">
					{/* First Name */}
					<div>
						<div className="flex items-center gap-2 mb-3">
							<label htmlFor="first-name" className={styles.label}>
								First name
							</label>
							<img src={questionIcon} alt="help icon" className="w-3 h-3" />
						</div>
						<input
							id="first-name"
							type="text"
							placeholder={firstNamePlaceholder}
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							className="w-full rounded-[10px] border-1p3 border-lightGrey px-4 py-3 text-base"
						/>
					</div>

					{/* Last Name */}
					<div>
						<div className="flex items-center gap-2 mb-3">
							<label htmlFor="last-name" className={styles.label}>
								Last name
							</label>
							<img src={questionIcon} alt="help icon" className="w-3 h-3" />
						</div>
						<input
							id="last-name"
							type="text"
							placeholder={lastNamePlaceholder}
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							className="w-full rounded-[10px] border-1p3 border-lightGrey px-4 py-3 text-base"
						/>
					</div>

					{/* Email Address */}
					<div>
						<div className="flex items-center gap-2 mb-3">
							<label htmlFor="email-address" className={styles.label}>
								Email address
							</label>
							<img src={questionIcon} alt="help icon" className="w-3 h-3" />
						</div>
						<input
							id="email-address"
							type="email"
							placeholder={emailPlaceholder}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							disabled={isEdit}
							className="w-full rounded-[10px] border-1p3 border-lightGrey px-4 py-3 text-base disabled:bg-gray-100 disabled:text-gray-500"
						/>
					</div>
				</div>

				<div className="h-[1px] bg-[#F0F0F0] mb-[30px] mx-[-30px]" />

				{/* Buttons */}
				<div className="flex gap-3 flex-col">
					<Button>{primaryButtonText}</Button>
					{isEdit && <Button variant="outline-gradient-text">Deactivate sub-admin</Button>}
				</div>
			</div>
		</div>
	);
}
